
export { AdminModule } from './admin.module';
// export { AdminService } from './admin.service';
export { AdminRoutingModule } from './admin-routing.module';



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/index.ts